<app-related-documents 
(relatedDocumentsSave)="saveOrUpdateChangeControl()" 
(moveToPreviousTab)="openPreviousTab()"
 [relatedDocumentsNotAlignedWithScopeConfirmationMessage]="documentScopeConfirmationMessage" 
 (relatedDocumentsAddition)="addRelatedDocuments()"
  [showRelatedDocumentsNotAlignedWithScopeConfirmationModal]="showRelatedDocumentsNotAlignedWithScopeConfirmationModal"
  [documentNumbersNotAlignedWithParentDocument]="documentNumbersNotAlignedWithParentDocument"
  [errorMessages]="errorMessages"
  [showDocumentLibrarySearch]="showDocumentLibrarySearch"
  [linkedDocuments]="linkedDocuments"
  [panelListScreen]="changeControlRelatedDocuments">
</app-related-documents>

<p-dialog
  [(visible)]="showDeletedFilesConfirmationModal"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ deleteAttachmentConfirmationMessage }}</span>
  </div>
  <ul>
    <li *ngFor="let deleteAttachment of deletedAttachments">
      {{ deleteAttachment.attachmentPath }}
    </li>
  </ul>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
    label="No"
    type="submit"
    icon="pi pi-times"
    id="deletedFilesConfirmationNoButton"
    styleClass="p-button-outlined"
    class="align-right"
    (debounceClick)="closeConfirmationModal()"
  >
  </p-button>
    <p-button
      appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="deletedFilesConfirmationYesButton"
      class="align-right"
      (debounceClick)="updateChangeManagement()"
    >
    </p-button>
   
  </ng-template>
</p-dialog>

<app-dialog *ngIf="isReasonForChangeControlUpdateRequired"[reasonValidationMessage]="reasonValidationMessage"[heading]="heading"(saveDocumentwithReason)="saveChangeControlwithReason($event)" (isModelOpen)="closeReasonDailog($event)">  
</app-dialog>

<app-confirmation-dialog *ngIf="isInActiveAssignmentGroupDialog" [InactiveAssignmentGroupField]="InactiveAssignmentGroupField" (confirmed)="saveChangeControlwithInactiveUsers()" (dialogClosed)="closeConfirmationDailog($event)">
</app-confirmation-dialog>
